export enum TelegramLinks {
  TELEGRAM_ACCOUNT_ASSIGN = "https://t.me/ft_workbot?start=",
}
